import React from "react";

/**
 * PatternOverlay
 *
 * NOTE (2026-02): We now use ONE global viewport-anchored pattern layer at
 * the App root (see <GlobalPattern/>) instead of a pattern per section.
 * That single layer stays anchored on mobile too (fixes the iOS Safari
 * `background-attachment: fixed` issue) and — critically — it prevents the
 * visible "sliding double overlay" that occurred when a fixed layer and a
 * section-scrolled layer were both visible during scroll.
 *
 * This component is now a deliberate no-op so any existing call site keeps
 * mounting cleanly without adding a second pattern that would slide against
 * the global one. The only place we still want a locally-attached pattern
 * is the sticky Header, which inlines its own layer directly.
 */
export default function PatternOverlay() {
  return null;
}
